export default [
  {
    name: 'project_navigation',
    component_path: 'modules/templates/blocks/project/ProjectNavigation',
  }
]